import { AxiosMethods, PriceGroupApi } from '@setvi/shared/enums';
import { PriceGroup } from '@setvi/shared/interfaces';
import { axiosHelper } from '@setvi/shared/services';
import {
  QueryFunctionContext,
  UseInfiniteQueryOptions
} from '@tanstack/react-query';

enum PriceGroupKeys {
  PriceGroups = 'priceGroups',
  PriceGroupDetails = 'priceGroup',
  Pricing = 'Pricing'
}

export interface UsePriceGroupsProps {
  searchStr: string;
}

const PAGE_SIZE = 20;

export const getPriceGroup = async (id: PriceGroup['_id']) => {
  const response = await axiosHelper({
    baseURL: process.env.REVOPS_API,
    endpoint: PriceGroupApi.GroupDetails.replace(':id', id),
    method: AxiosMethods.GET
  });
  return response;
};

const fetchPriceGroups = async (
  props: QueryFunctionContext<(string | UsePriceGroupsProps)[]>
): Promise<PriceGroup[]> => {
  const { pageParam = 0, queryKey } = props;
  const [, filters] = queryKey as [string, UsePriceGroupsProps];

  const { searchStr } = filters;

  const response = await axiosHelper({
    baseURL: process.env.REVOPS_API,
    endpoint: PriceGroupApi.GetPriceGroups,
    method: AxiosMethods.POST,
    body: {
      limit: PAGE_SIZE,
      offset: pageParam,
      searchStr
    }
  });

  return response.data;
};

export const getPriceGroups = (
  filters: UsePriceGroupsProps
): UseInfiniteQueryOptions<PriceGroup[]> => ({
  queryKey: [PriceGroupKeys.PriceGroups, filters],
  queryFn: fetchPriceGroups,
  getNextPageParam: (lastPage, allPages) => {
    if (lastPage.length < PAGE_SIZE) return undefined;
    return allPages.length * PAGE_SIZE;
  }
});
